import {Injectable} from '@angular/core';
import {ApiService} from '../../../../services/api.service';
import {Subject} from 'rxjs';
import {ErrorService} from '../../../../services/error.service';

@Injectable()
export class AwardManageService {
  private observer = new Subject();
  public award = this.observer.asObservable();

  constructor(private apiService: ApiService, private errorService: ErrorService) {
  }

  public updateAward(id) {
    this.apiService.getAward(id).subscribe((response: any) => {
      this.observer.next(response.data);
    }, error => {
      this.errorService.handleError(error);
    });
  }
}
